import { EventParameters } from '@ccmn/analytics';

const sendEvent = (params: EventParameters): void => {
    if (typeof Analytics !== 'undefined' && Analytics) {
        Analytics.sendEvent(params);
    } else {
        console.warn('Analytics is not defined or not available.');
    }
};

export default sendEvent;
